import React from 'react';
import styled from 'styled-components';
import { IToastActionLink } from './HBToast.types';
import HBText from '../HBText/HBText';

interface Props {
    actionLink: IToastActionLink;
    onActionClick: (action: IToastActionLink) => void;
}

const ToastActionLink = ({
    actionLink,
    actionLink: { color, testIdName, text, type },
    onActionClick
}: Props) => {
    return (
        <ActionLink
            {...actionLink}
            color={color || 'blue20'}
            onClick={() => onActionClick(actionLink)}
            testId={
                testIdName ? `hb-toast-${testIdName}-action--link` : undefined
            }
            type={type || 'emphasis14'}
        >
            {text}
        </ActionLink>
    );
};

export default ToastActionLink;

// -------------------------------- Styles -------------------------------- //
const ActionLink = styled(HBText)`
    text-align: right;
`;
